import { h } from 'preact'
import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => (
  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M9.76618 2.23335C8.79952 1.26669 7.47285 0.666687 5.99952 0.666687C3.05285 0.666687 0.672852 3.05335 0.672852 6.00002C0.672852 8.94669 3.05285 11.3334 5.99952 11.3334C8.48619 11.3334 10.5595 9.63335 11.1529 7.33335H9.76618C9.21952 8.88669 7.73952 10 5.99952 10C3.79285 10 1.99952 8.20669 1.99952 6.00002C1.99952 3.79335 3.79285 2.00002 5.99952 2.00002C7.10618 2.00002 8.09285 2.46002 8.81285 3.18669L6.66618 5.33335H11.3329V0.666687L9.76618 2.23335Z' fill='#2B3346' />
  </svg>
)
